import { readable, writable } from "svelte/store";
import ActivitiesService from "./ActivitiesService";
import { BearingCalculator } from "./BearingCalculator";
import { ChallengeFactory } from "./ChallengeFactory";
import CheckpointsFactory from "./CheckpointsFactory";
import { DistanceCalculator } from "./DistanceCalculator";
import { Geolocation } from "./Geolocation";
import { PicturesService } from "./PicturesService";
import QuestionsService from "./QuestionsService";
import { RaceService } from "./RaceService";
import { RandomId } from "./RandomId";
import { RoutesService } from "./RoutesService";
const user = writable(null);
const appColor = writable('');
const geolocation = new Geolocation();
const randomId = new RandomId();
const distanceCalculator = new DistanceCalculator();
const picturesService = new PicturesService('https://picture-service.echeide.es/service');
const challengeFactory = new ChallengeFactory(distanceCalculator);
const questionsService = new QuestionsService('/questions.json');
const activitiesService = new ActivitiesService();
const checkpointsFactory = new CheckpointsFactory(activitiesService);
const routesService = new RoutesService(checkpointsFactory);
const raceService = new RaceService();
const bearingCalculator = new BearingCalculator();
const isGeolocated = readable(false, set => {
    return geolocation.subscribe(() => set(true));
});
export { user, appColor, geolocation, randomId, raceService, distanceCalculator, picturesService, challengeFactory, questionsService, activitiesService, routesService, isGeolocated, bearingCalculator, };
